module.exports = __webpack_public_path__ + "static/jumboLoansHeroBg-6595026a7a1ca40fcbd845588acc73df.jpg";